/**
 * @Author : zhouqinze
 * @Date : 2019-12-29
 * @Version : 1.0
 * @Content : 联系我们
 **/
<template>
    <div>
        <div class="aboutComHead">
            <p>联系我们</p>
            <p><span></span><span></span></p>
        </div>
        <div class="conCon">
            <div class="conBox"><div class="boxLeft">通易联系方式：</div><div class="boxRight"><p>电话：020-38481073</p><p>邮编：510653</p><p>电子邮箱：cyw@comit.com.cn</p></div></div>
            <div class="conBox"><div class="boxLeft">优驾联系方式：</div><div class="boxRight"><p>电话：400-800-1489</p><p>微信号：igooddriver</p><p>优驾服务邮件：biz@gooddriver.cn</p></div></div>
            <div class="conBox"><div class="boxLeft">地址：</div><div class="boxRight"><p>广州市天河区翰景路1号金星大厦14楼</p></div></div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    .aboutComHead{
        width: 5.875rem;
        font-size: 1.4375rem;
        color: #333;
        margin-bottom: .75rem;
        font-weight: bold;
        margin-bottom: 1.25rem;
        span{
            display: inline-block;
            width: 50%;
            height: .1875rem;
            background: #018CF4;
        }
        span:last-child{
            background: #ddd;
        }
    }
    .conCon{
        width: 100%;
        .conBox{
            display: flex;
            margin-bottom: 1.3125rem;
            .boxLeft{
                width: 7.9375rem;
                text-align: end;
                font-size: 1.125rem;
                color: #333;
                margin-right: 25px;
            }
            .boxRight{
                font-size: 1rem;
                p{
                    text-align: start;
                    height: 2.0625rem;
                    color: #666;
                }
            }
        }
    }
</style>